(() => {
	angular
		.module('main')
		.directive('deleteExtrashootModal', deleteExtrashootModal);

	deleteExtrashootModal.$inject = [];

	function deleteExtrashootModal() {
		return {
			restrict: 'E',
			scope: {
				delete: '&',
				mainShootLabelName: '=',
				extraShootLabelName: '='
			},
			template: `
                    <div id="deleteExtrashootModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                   <btn-close></btn-close>
                                    <h3 class="modal-title">Delete {{extraShootLabelName | lowercase}}</h3>
                                </div>
                                <div class="modal-body">
                                    <strong>
                                      Are you sure you would like to delete this {{extraShootLabelName | lowercase}}?
                                    </strong>
                                </div>
                                <div class="modal-footer modal-foot">
                                    <button class="btn btn-danger btn-lg" ng-click="delete()">Delete {{extraShootLabelName | lowercase}}</button>
                                    <button class="btn btn-default btn-lg" data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
             `,
			replace: true,
			transclude: true,
			link(scope) {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/deleteExtrashootModal.js